import {
    BTGPatientType
} from 'one-state-btgpatient/src/model';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Epic User Id Component
 * @param response has the backend
 * Epic User Id  component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result: any = {
        patientbtgdata: {},
        error: undefined
    }

    const { log, settings } = context;
    const { compatible: { sso } } = settings;
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
    }
    else {
        let searchobj: BTGPatientType = {
            resourceType: "Patient"
        };
        if (response?.output?.results?.length > 0) {
            response.output.results.forEach((btginfo: any) => {
                if (btginfo?.OperationOutcome) {
                    searchobj.resourceType = "OperationOutcome"
                }
            })
        }
        result.patientbtgdata = searchobj
        log.debug(
            "ccw-gadget,Agent-cerner",
            "Agent-cerner transformation response ", {
            result
        });
    }
    return result;
}